exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-core-video-player-control.timespan{line-height:30px;width:140px;font-family:Arial!important}", ""]);

// exports
